import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { SubscriptionsType } from '@src/store/ducks/subscriptions/types'

export const initialState = {
  subscriptions: [] as SubscriptionsType[],
  isLoading: false,
  isLoadingChangeSubscription: false,
  isSuccessChangeSubscription: false,
  subscriptionSuccessMessage: '',
}
const subscriptionsSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    setSubscriptions(state, { payload }: PayloadAction<SubscriptionsType[]>) {
      state.subscriptions = payload
    },
    setIsLoadingSubscriptions(state, { payload }: PayloadAction<boolean>) {
      state.isLoading = payload
    },
    setIsLoadingChangeSubscription(state, { payload }: PayloadAction<boolean>) {
      state.isLoadingChangeSubscription = payload
    },
    setIsSuccessChangeSubscription(state, { payload }: PayloadAction<boolean>) {
      state.isSuccessChangeSubscription = payload
    },
    setSubscriptionSuccessMessage(state, { payload }: PayloadAction<string>) {
      state.subscriptionSuccessMessage = payload
    },
    resetSubscriptions: () => initialState,
  },
})
export type TariffsStateType = typeof initialState

export const {
  setSubscriptions,
  setIsLoadingSubscriptions,
  setIsLoadingChangeSubscription,
  setIsSuccessChangeSubscription,
  setSubscriptionSuccessMessage,
  resetSubscriptions,
} = subscriptionsSlice.actions
export const subscriptionsReducer = subscriptionsSlice.reducer
